/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RegisterAdvertiserRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {RegisterAdvertiserResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const registerAdvertiser = (request: RegisterAdvertiserRequest, options?: CashRequestOptions) => post<RegisterAdvertiserRequest, RegisterAdvertiserResponse>("/2.0/cash/register-advertiser", request, {...options, rejectOnError: true })